<template>
    <div class="type-manager">
        <div class="type-manager-new">
            <div class="d-flex align-items-start">
                <div class="flex-grow-1">
                    <h6>{{ id ? 'Bewerk type' : 'Maak een nieuw type'}}</h6>
                    <h2>{{ form.name ? form.name : 'Nieuw afspraak type' }}</h2>
                </div>

                <b-button type="button"
                    v-if="id"
                    class="mr-2"
                    variant="outline-secondary"
                    v-b-tooltip.hover
                    title="Maak nieuw type"
                    @click="createNewType"
                >
                    <i class="fa fa-fw fa-reply"></i>
                </b-button>

                <b-button type="button"
                    class="mr-2"
                    variant="outline-primary"
                    v-b-tooltip.hover
                    :title="id ? 'Opslaan' : 'Maak aan'"
                    @click="id ? update() : create()"
                >
                    <loader-spinner v-if="isUpdatingType || isCreatingType" iscolor="#F0F0F0" :show-spinner="true" />
                    <fa-icon v-else-if="id" icon="save" />
                    <fa-icon v-else icon="plus" />
                </b-button>

                <b-button type="button"
                    variant="outline-secondary"
                    v-b-tooltip.hover
                    title="Sluit"
                    @click="$emit('close')"
                >
                    <fa-icon icon="times" />
                </b-button>
            </div>

            <general-input
                v-model="form.name"
                label="Titel"
                placeholder="Vul een titel in"
            />

            <div class="type-manager-color-input mt-2">
                <label class="label">Kleur</label>
                <input v-model="form.color" type="color" value="#FFFFFF">
            </div>

            <general-input
                class="type-manager-email-note-input mt-2"
                label="Inhoud email"
                inputType="textarea"
                placeholder=""
                v-model="form.email_note"
            />
        </div>

        <div class="type-manager-current mt-4">
            <h4 class="mb-3">Huidige types</h4>

            <calendar-type v-for="type in calendarTypes" 
                :key="type.id"
                :calendarType="type"
                class="mb-3"
                @edit="editType"
                @deleted="deletedType"
            />

            <div v-if="!calendarTypes.length" class="type-manager-empty-types">
                Er zijn nog types aangemaakt.
            </div>
        </div>
    </div>
</template>

<script>
import LoaderSpinner from '../../elements/LoaderSpinner';
import GeneralInput from '../../elements/Input/GeneralInput';
import CalendarType from './CalendarType';
import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
        GeneralInput,
        CalendarType,
        LoaderSpinner
    },
    props: {
        calendarTypes: {
            type: Array,
        }
    },
    data: () => ({
        id: null,
        form: {
            color: '#FFFFFF'
        }
    }),
    computed: {
        ...mapGetters([
            'isCreatingType',
            'isUpdatingType',
        ])
    },
    methods: {
        ...mapActions([
            'createType',
            'updateType',
        ]),

        createNewType() {
            this.id = null;
            this.form = {
                color: '#FFFFFF'
            };
        },

        editType(id) {
            const type = this.calendarTypes.find(el => el.id == id);

            this.id = id;
            this.form = {
                name: type.name,
                color: type.bgColor,
                email_note: type.email_note,
            }
        },

        deletedType(id) {
            if (this.id == id) this.id = null;

            this.$emit('update');
        },

        async update() {
            try {
                const response = await this.updateType({
                    id:     parseInt(this.id),
                    params: this.form
                });

                this.id = response.id.toString();

                this.$emit('update');
            }
            catch (error) {
                console.log(error);
            }
        },

        async create() {
            try {
                const response = await this.createType(this.form);

                this.$emit('update');

                this.id = response.id.toString();
            }
            catch (error) {
                console.log(error);
            }
        },
    },
    mounted () {}
}
</script>

<style lang="scss">
.type-manager {
    &-email-note-input {
        height: 200px;
    }

    &-color-input {
        label {
            color: black;
            font-size: 1rem;
            font-weight: 600;
            display: inline-block;
        }

        input {
            background: white;
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 5px;
            padding: 0.5rem 0.5rem;
            font-size: 14px;
            font-weight: 400;
            width: 100%;
            min-height: 43px;
        }
    }

    &-empty-types {
        font-style: italic;
    }
}
</style>


// WEBPACK FOOTER //
// TypeManager.vue?0665f148